import { ApplicationRef, ChangeDetectionStrategy, Component } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { environment } from '@pg-env/environment';
import { concat, interval, Subscription } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { DestroyableDirective } from '../../destroyable';

@Component({
    selector: 'np-check-version',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class CheckVersionComponent extends DestroyableDirective {
    swUpdateSubscription: Subscription;

    constructor(
        private readonly appRef: ApplicationRef,
        private readonly swUpdate: SwUpdate,
    ) {
        super();
        // if browser supports service worker
        if (this.swUpdate.isEnabled) {
            // wait until app is stable
            const appIsStable$ = this.appRef.isStable.pipe(first((isStable) => isStable === true));
            // check every 5 mins
            const checkVersion$ = interval(environment.timeCheckVersion);
            const checkVersionOnceAppIsStable$ = concat(appIsStable$, checkVersion$);
            checkVersionOnceAppIsStable$
                .pipe(takeUntil(this.$destroyed))
                .subscribe(() => {
                    this.swUpdate.checkForUpdate();
                });

            this.swUpdateSubscription = this.swUpdate.available.subscribe(() => {
                // refresh without no message if first time open browser after deploy
                window?.location?.reload();
            });
        }
    }
}

